
import {
    FETCH_TRANSACTION_HISTORY_REQUEST,
    FETCH_TRANSACTION_HISTORY_SUCCESS,
    FETCH_TRANSACTION_HISTORY_FAILURE,
  } from "../actions/TranscationHistoryType"
  
  const initialState = {
    transactions: [],
    loading: false,
    error: null,
  };
  
  const transactionReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_TRANSACTION_HISTORY_REQUEST:
        return { ...state, loading: true, error: null };
      case FETCH_TRANSACTION_HISTORY_SUCCESS:
        return { ...state, loading: false, transactions: action.payload };
      case FETCH_TRANSACTION_HISTORY_FAILURE:
        return { ...state, loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  export default transactionReducer;
  